import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { duration, easing } from '@twistopayments/design-system/styles';

export const ArrowClassName = 'arrow';

export const arrow = (theme: Theme, sizeVariant: 'small' | 'medium') => css`
  position: absolute;
  top: -${theme.spacing[8]};
  left: ${sizeVariant === 'small' ? '13px' : '15px'};
  overflow: hidden;
  height: ${theme.spacing[8]};
  width: ${theme.spacing[20]};

  &:after {
    content: '';
    border-radius: 2px 0 0 0;
    position: absolute;
    width: ${theme.spacing[12]};
    height: ${theme.spacing[12]};
    transform: rotate(45deg);
    background-color: ${theme.palette.tertiary.lowContrast};
    transition: background-color ${duration.shortest}ms ${easing.easeOut};
    top: 2px;
    left: 3px;
  }
`;

export const button = (theme: Theme) => css`
  border-radius: ${theme.spacing[4]};
  padding: ${theme.spacing[12]};
  border: none;
  background: transparent;
  background-color: ${theme.palette.tertiary.lowContrast};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing[8]};
  color: ${theme.palette.tertiary.main};
  position: relative;
  box-sizing: border-box;
  width: 100%;

  &:disabled {
    background-color: ${theme.palette.tertiary.lowContrast};
    color: ${theme.palette.text.disabled};
  }
`;

export const buttonActive = (theme: Theme) => css`
  transition: background-color ${duration.shortest}ms ${easing.easeOut};
  cursor: pointer;
  color: ${theme.palette.tertiary.main};

  &:hover,
  &:focus,
  &:active {
    background-color: ${theme.palette.tertiary.mediumContrast};
    transition: background-color ${duration.shortest}ms ${easing.easeIn};
  }

  &:hover .${ArrowClassName}, &:focus .${ArrowClassName}, &:active .${ArrowClassName} {
    &:after {
      background-color: ${theme.palette.tertiary.mediumContrast};
      transition: background-color ${duration.shortest}ms ${easing.easeIn};
    }
  }
`;

export const text = css`
  flex-grow: 1;
`;
